import React from 'react'
import { CFooter } from '@coreui/react'

const SupportFooter = () => {
     return (
          <CFooter fixed={false}>
          </CFooter>
     )
}

export default React.memo(SupportFooter)
